export default {
  name: 'dickeyval',
  getValList(val) {
    return this[val]
  },

  // 认证状态
  AUTH_STATUS: [
    {
      val: '-1',
      text: '未认证'
    },
    {
      val: '0',
      text: '认证审核中'
    },
    {
      val: '1',
      text: '已认证'
    },
    {
      val: '2',
      text: '认证失败'
    }
  ],

  // 签约状态
  SIGN_STATUS: [
    {
      val: '0',
      text: '待签约'
    },
    {
      val: '1',
      text: '签约中'
    },
    {
      val: '2',
      text: '已签约'
    },
    {
      val: '3',
      text: '已作废'
    }
  ],

  // 经营模式
  BUSSINESS_TYPE: [
    {
      val: '0',
      text: '年度'
    },
    {
      val: '1',
      text: '季度'
    }
  ],

  // 经营季度
  QUARTER_TYPE: [
    {
      val: '1',
      text: '春季(3月-5月)'
    },
    {
      val: '2',
      text: '夏季(6月-8月)'
    },
    {
      val: '3',
      text: '秋季(9月-11月)'
    },
    {
      val: '4',
      text: '冬季(12月-次年2月)'
    }
  ],

  // 经营周期
  WEEK_TYPE: [
    {
      val: '1',
      text: '星期一'
    },
    {
      val: '2',
      text: '星期二'
    },
    {
      val: '3',
      text: '星期三'
    },
    {
      val: '4',
      text: '星期四'
    },
    {
      val: '5',
      text: '星期五'
    },
    {
      val: '6',
      text: '星期六'
    },
    {
      val: '7',
      text: '星期天'
    }
  ],

  // 店铺状态
  STORE_STATIS: [
    {
      id: '1',
      name: '营业中'
    },
    {
      id: '2',
      name: '暂停营业'
    },
    {
      id: '3',
      name: '筹建中'
    },
    {
      id: '4',
      name: '已关店'
    }
  ],

  // 审核状态
  CHECK_STATUS: [
    {
      val: '0',
      text: '未审核'
    },
    {
      val: '1',
      text: '已审核'
    },
    {
      val: '2',
      text: '审核失败'
    }
  ],

  // 商户模式
  MERCHANT_TYPE: [
    {
      val: '1',
      text: '个体工商户'
    },
    {
      val: '2',
      text: '企业法人'
    }
  ],

  // 积分获取类型
  POINT_TYPE: [
    {
      val: '1',
      text: '支付获得'
    },
    {
      val: '2',
      text: '支付抵扣'
    },
    {
      val: '3',
      text: '签到'
    },
    {
      val: '4',
      text: '邀请好友'
    },
    {
      val: '5',
      text: '退款返还'
    },
    {
      val: '6',
      text: '退款扣除'
    },
    {
      val: '7',
      text: '用户导入'
    },
    {
      val: '8',
      text: '邀请好友'
    }
  ],

  // APP类型
  APP_TYPE: [
    {
      val: '1',
      text: '安卓'
    },
    {
      val: '2',
      text: '苹果'
    }
  ],

  // 资质规范
  SPECIFICATION_TYPE: [
    {
      val: '1',
      text: '平台资质'
    },
    {
      val: '2',
      text: '协议及隐私政策 '
    },
    {
      val: '3',
      text: '经营规范'
    }
  ],

  // 操作日志类型
  OPER_MODAL: [
    {
      val: '1',
      text: '商家管理'
    },
    {
      val: '2',
      text: '商家角色管理'
    },
    {
      val: '3',
      text: '商家账号管理'
    },
    {
      val: '4',
      text: '店铺管理'
    },
    {
      val: '5',
      text: '财务管理'
    }
  ],

  // 家政订单状态
  SUBSCRIBE_ORDER_STATUS: [
    {
      val: '1',
      text: '已完成'
    },
    {
      val: '2',
      text: '已预约'
    },
    {
      val: '3',
      text: '已接单'
    },
    {
      val: '4',
      text: '服务中'
    },
    {
      val: '5',
      text: '已作废'
    },
    {
      val: '6',
      text: '已取消'
    },
    {
      val: '7',
      text: '待结算'
    },
    {
      val: '8',
      text: '已下单'
    }
  ],

  // 团购订单状态
  ORDER_GROUP_STATUS: [
    {
      val: 'all',
      text: '全部'
    },
    {
      val: '0',
      text: '待付款'
    },
    {
      val: '5',
      text: '待使用'
    },
    {
      val: '3',
      text: '待收货'
    },
    {
      val: '2',
      text: '待发货'
    },
    {
      val: '1',
      text: '已完成'
    },
    {
      val: '4',
      text: '已取消'
    },
    {
      val: '6',
      text: '已退款'
    },
    {
      val: '7',
      text: '退款中'
    },
    {
      val: '8',
      text: '拣货中'
    }
  ],

  // 券码状态
  CODE_STATUS: [
    {
      val: '1',
      text: '待履约'
    },
    {
      val: '2',
      text: '已履约'
    },
    {
      val: '3',
      text: '已过期'
    },
    {
      val: '4',
      text: '已退款'
    },
    {
      val: '5',
      text: '退款中'
    },
    {
      val: '6',
      text: '履约中'
    },
    {
      val: '7',
      text: '履约完结'
    },
    {
      val: '8',
      text: '售后中'
    },
    {
      val: '9',
      text: '履约关闭'
    }
  ],

  // 团单状态
  GROUP_STATUS: [
    {
      val: '1',
      text: '未上架'
    },
    {
      val: '2',
      text: '已上架'
    },
    {
      val: '3',
      text: '即将下架'
    },
    {
      val: '4',
      text: '已下架'
    }
  ],

  // 团单类型
  GROUP_TYPE: [
    {
      val: '1',
      text: '团购券'
    },
    {
      val: '2',
      text: '实物商品'
    },
    {
      val: '3',
      text: '优惠券'
    }
  ],

  // 团单业务类型
  GROUP_BUSINESS_TYPE: [
    {
      val: '1',
      text: '综合类'
    },
    {
      val: '2',
      text: '家政类'
    },
    {
      val: '3',
      text: '洗护类'
    },
    {
      val: '4',
      text: '商品类'
    }
  ],

  // 团单销售状态
  SALE_STATUS: [
    {
      val: '1',
      text: '未开售'
    },
    {
      val: '2',
      text: '抢购中'
    },
    {
      val: '3',
      text: '已经售罄'
    },
    {
      val: '4',
      text: '已结束'
    }
  ],

  // 分佣级别
  GROUP_LEVEL: [
    {
      id: '1',
      name: '普通用户'
    },
    {
      id: '2',
      name: '实习小团长' // 无该等级
    },
    {
      id: '3',
      name: '小团长'
    },
    {
      id: '4',
      name: '大团长'
    }
  ],
  COMMISSION_TIX_STATUS: [
    {
      id: '1',
      name: '申请时间'
    },
    {
      id: '2',
      name: '提现时间'
    }
  ],
  COMMISSION_PRICE_TYPE: [
    {
      id: '0',
      name: '全部'
    },
    {
      id: '1',
      name: '直卖/自购佣金'
    },
    {
      id: '3',
      name: '团队佣金'
    }
  ],
  // 分佣类型
  COMMISSION_TYPE: [
    {
      val: '1',
      text: '自购佣金'
    },
    {
      val: '2',
      text: '直卖佣金'
    },
    {
      val: '3',
      text: '团队佣金'
    }
  ],

  // 物流状态
  LOGISTICS_STATUS: [
    {
      val: '1',
      text: '已发货'
    },
    {
      val: '2',
      text: '已完成'
    }
  ],

  // 退款状态
  REFUND_STATUS_VAL: [
    {
      val: '1',
      text: '退款失败'
    },
    {
      val: '2',
      text: '申请中'
    },
    {
      val: '3',
      text: '退款中'
    },
    {
      val: '4',
      text: '退款成功'
    }
  ],

  // 退单状态
  REFUND_STATUS: [
    {
      id: 1,
      name: '退款失败'
    },
    // { id: 2, name: '申请中' },
    {
      id: 3,
      name: '退款中'
    },
    {
      id: 4,
      name: '退款成功'
    }
  ],
  // isWriteOff 劵码状态(1：未核销；2：已核销；3：已过期；4：已失效；5：退款中；6：已预约)
  // REFUND_WriteOff: [
  //   {
  //     val: '1',
  //     text: '未核销'
  //   },
  //   {
  //     val: '2',
  //     text: '已核销'
  //   },
  //   {
  //     val: '3',
  //     text: '已过期'
  //   },
  //   {
  //     val: '4',
  //     text: '已退款'
  //   },
  //   {
  //     val: '5',
  //     text: '退款中'
  //   },
  //   {
  //     val: '6',
  //     text: '待派单'
  //   },
  //   {
  //     val: '7',
  //     text: '履约完结'
  //   },
  //   {
  //     val: '8',
  //     text: '售后中'
  //   },
  //   {
  //     val: '9',
  //     text: '履约关闭'
  //   }
  // ],

  // 优惠券
  SUBSCRIBE_coupons_STATUS: [
    {
      text: '全部',
      val: '',
      number: 0
    },
    {
      val: '1',
      text: '商品直减券',
      number: 0,
      subName: '对指定商品直接减去金额',
      router: 'wxApp/index'
    },
    // {
    //   val: "2",
    //   text: "满减券",
    //number:0,,
    // subName: "满一定金额，可减去金额",
    // router: "wxApp/index"},
    // },
    {
      val: '3',
      text: '商品折扣券',
      number: 0,
      subName: '对指定的商品进行打折',
      router: 'wxApp/index'
    },
    {
      val: '4',
      text: '买赠券',
      number: 0,
      subName: '买商品赠送商品',
      router: 'wxApp/index'
    },
    // {
    //   val: "5",
    //   text: "第二件打折券",
    // number:0,,
    // subName: "对第二件进行打折",
    // router: "wxApp/index"},
    // },
    {
      val: '6',
      text: '兑换券',
      number: 0,
      subName: '可兑换指定的商品',
      router: 'wxApp/index'
    }
  ],
  coupons_LIST: [
    {
      id: 1,
      name: '商品直减券',
      subName: '对指定商品直接减去金额',
      router: 'wxApp/index'
    },

    // {id:2,
    // name: "满减券",
    // subName: "满一定金额，可减去金额",
    // router: "wxApp/index"},

    {
      id: 3,
      name: '商品折扣券',
      subName: '对指定的商品进行打折',
      router: 'wxApp/index'
    },

    //   {id:4,
    // name: "买赠券",
    // subName: "买商品赠送商品",
    // router: "wxApp/index"},

    //   {id:5,
    // name: "第二件打折券",
    // subName: "对第二件进行打折",
    // router: "wxApp/index"},

    {
      id: 6,
      name: '兑换券',
      subName: '可兑换指定的商品',
      router: 'wxApp/index'
    }
  ],
  //打单状态
  PRINT_STATUS: [
    {
      val: '2',
      text: '未打印'
    },
    {
      val: '1',
      text: '打印成功'
    },
    {
      val: '0',
      text: '打印失败'
    },

    {
      val: '-1',
      text: '订单json格式错误'
    },
    {
      val: '-2',
      text: 'data字段内容为空'
    },
    {
      val: '-3',
      text: '打印失败'
    },
    {
      val: '3',
      text: '打印异常'
    },
    {
      val: '99',
      text: '店铺未绑定打印机'
    }
  ],
  //商品订单状态
  ERRAND_STATUS: [
    {
      val: '0',
      text: '已下单'
    },
    {
      val: '1',
      text: '已到店取'
    },
    {
      val: '2',
      text: '已备单'
    },
    {
      val: '4',
      text: '已取消'
    },
    {
      val: '6',
      text: '已退单'
    },
    {
      val: '7',
      text: '退款中'
    },
    {
      val: '11',
      text: '已接单'
    },
    {
      val: '30',
      text: '配送中'
    },
    {
      val: '31',
      text: '配送完成'
    },
    {
      val: '32',
      text: '已送达'
    }
  ],
  //洗护订单状态
  WASH_STATUS: [
    {
      val: '0',
      text: '已下单'
    },
    {
      val: '1',
      text: '已下单待分拣'
    },
    {
      val: '2',
      text: '分拣中'
    },
    {
      val: '3',
      text: '已分拣'
    },
    {
      val: '4',
      text: '已取消'
    },
    {
      val: '5',
      text: '已质检已洗完'
    },
    {
      val: '6',
      text: '已签收'
    },
    {
      val: '7',
      text: '已完成'
    },
    {
      val: '8',
      text: '已退洗'
    },
    {
      val: '9',
      text: '已返洗'
    },
    {
      val: '10',
      text: '已到店'
    },
    {
      val: '11',
      text: '已退单'
    },
    {
      val: '12',
      text: '退款失败'
    },
    {
      val: '13',
      text: '退款中'
    },
    {
      val: '14',
      text: '已下单待派单'
    },
    {
      val: '15',
      text: '已派单待取件'
    },
    {
      val: '16',
      text: '已取件'
    },
    {
      val: '17',
      text: '已发货'
    },
    {
      val: '18',
      text: '发货已取件'
    },
    {
      val: '19',
      text: '已复拣，洗涤中'
    },
    {
      val: '20',
      text: '到达洗护工厂'
    },
    {
      val: '22',
      text: '工厂已分拣'
    },
    {
      val: '40',
      text: '已下单待投入'
    },
    {
      val: '41',
      text: '已投入设备'
    },
    {
      val: '42',
      text: '已在设备取件'
    },
    {
      val: '43',
      text: '已回柜'
    }
  ],
  //估价订单状态
  EVALUATE_STATUS: [
    {
      val: '-1',
      text: '已取消'
    },
    {
      val: '1',
      text: '已下单'
    },
    {
      val: '2',
      text: '待估价'
    },
    {
      val: '3',
      text: '已初估'
    },
    {
      val: '4',
      text: '已终估'
    }
  ],
  //回收订单状态
  RECOVERY_STATUS: [
    {
      val: '0',
      text: '已取消'
    },
    {
      val: '1',
      text: '已下单寄出'
    },
    {
      val: '2',
      text: '已报价'
    },
    {
      val: '3',
      text: '已同意报价'
    },
    {
      val: '4',
      text: '回收完成'
    },
    {
      val: '5',
      text: '退回待寄件'
    },
    {
      val: '6',
      text: '退回已寄件'
    }
  ],
  // 衣物状态
  CLOTH_STATUS: [
    {
      id: '1',
      name: '已下单待分拣'
    },
    {
      id: '2',
      name: '分拣中'
    },
    {
      id: '3',
      name: '已分拣'
    },
    {
      id: '4',
      name: '已质检'
    },
    {
      id: '5',
      name: '已到店'
    },
    {
      id: '6',
      name: '已签收'
    },
    {
      id: '7',
      name: '已完成'
    },
    {
      id: '8',
      name: '已退洗'
    },
    {
      id: '9',
      name: '已返洗'
    },
    {
      id: '19',
      text: '已复拣，洗涤中'
    },
    {
      id: '20',
      name: '已取消'
    },
    {
      id: '21',
      name: '已上挂'
    },
    {
      id: '22',
      name: '工厂已分拣'
    },
    {
      id: '30',
      name: '门店已备'
    },
    {
      id: '31',
      name: '物流从门店揽收'
    },
    {
      id: '32',
      name: '物流送到工厂'
    },
    {
      id: '33',
      name: '工厂已接收'
    },
    {
      id: '34',
      name: '工厂已备'
    },
    {
      id: '35',
      name: '物流从工厂揽收'
    },
    {
      id: '36',
      name: '物流送到门店'
    }
  ],
  // 附件状态
  ANNEX_STATUS: [
    {
      val: '1',
      text: '已核对'
    },
    {
      val: '2',
      text: '未核对'
    }
  ],
  TIME_TYPE_STATUS: [
    {
      id: '1',
      name: '下单时间'
    },
    {
      id: '2',
      name: '支付时间'
    }
  ],
  CARDTIME_TYPE_STATUS: [
    {
      id: '1',
      name: '购卡时间'
    },
    {
      id: '2',
      name: '过期时间'
    }
  ],
  COUPONTIME_TYPE_STATUS: [
    {
      id: '1',
      name: '获券时间'
    },
    {
      id: '2',
      name: '过期时间'
    },
    {
      id: '3',
      name: '使用时间'
    }
  ],
  BLANCE_STATUS: [
    {
      id: 1,
      name: '未结算'
    },
    {
      id: 2,
      name: '已结算'
    }
  ],
  QYWX_STATUS: [
    {
      id: '',
      name: '全部'
    },
    {
      id: '-1',
      name: '流失'
    },
    {
      id: '1',
      name: '未添加'
    },
    {
      id: '2',
      name: '已添加'
    }
  ],
  COMMON_STATUS: [
    {
      id: 1,
      name: '启用'
    },
    {
      id: 2,
      name: '停用'
    }
  ],
  COUPONSALE_STATUS: [
    {
      id: '',
      name: '全部'
    },
    {
      id: 0,
      name: '未开始'
    },
    {
      id: 1,
      name: '售卖中'
    },
    {
      id: 2,
      name: '已结束'
    }
  ],
  ACTIVITY_STATUS: [
    {
      id: '0',
      name: '未开始'
    },
    {
      id: '1',
      name: '进行中'
    },
    {
      id: '2',
      name: '已结束'
    }
  ],
  ACTIVITY_DO_STATUS: [
    {
      id: '1',
      name: '进行中'
    },
    {
      id: '2',
      name: '成功'
    },
    {
      id: '3',
      name: '失败'
    }
  ],
  AMOUNT_CHANGE_TYPE: [
    {
      id: 1,
      name: '充值'
    },
    {
      id: 2,
      name: '退款'
    },
    {
      id: 3,
      name: '消费'
    },
    {
      id: 4,
      name: '退卡'
    }
  ],
  SALE_ORIGIN: [
    {
      id: 1,
      name: '内部'
    },
    {
      id: 2,
      name: '外部'
    }
  ],
  CHANGE_REASON: [
    {
      id: 1,
      name: '达到条件升级'
    },
    {
      id: 2,
      name: '购买优卡'
    },
    {
      id: 3,
      name: '手动修改'
    },
    {
      id: 4,
      name: '未满条件降级'
    }
  ],
  USE_STATUS: [
    {
      id: 1,
      name: '启用'
    },
    {
      id: 2,
      name: '关闭'
    }
  ],
  LOSS_STATUS: [
    {
      id: 1,
      name: '留存'
    },
    {
      id: 2,
      name: '流失'
    }
  ],
  CARD_STATUS: [
    {
      id: 1,
      name: '正有效'
    },
    {
      id: 2,
      name: '已失效'
    }
    // {id:3,name:'赠送中'}
  ],
  YOUKA_SALE_STATUS: [
    {
      id: 1,
      name: '可售卖'
    },
    {
      id: 2,
      name: '不可售卖'
    }
  ],
  // 兑换码状态
  REDEEM_CODE_STATUS: [
    {
      id: 1,
      name: '未兑换'
    },
    {
      id: 2,
      name: '已兑换'
    },
    {
      id: 3,
      name: '已作废'
    }
  ],
  GETCOUPON_TYPE: [
    {
      id: '0',
      name: '全部'
    },
    {
      id: 1,
      name: '新人赠券'
    },
    {
      id: 2,
      name: '扫码领券'
    },
    {
      id: 3,
      name: '优卡'
    },
    {
      id: 4,
      name: '礼券售卖'
    },
    {
      id: 5,
      name: '系统发券'
    },
    {
      id: 6,
      name: '邀请有礼-邀请人'
    },
    {
      id: 7,
      name: '邀请有礼-被邀请人'
    },
    {
      id: 8,
      name: '拼手气'
    },
    {
      id: 9,
      name: '膨胀券'
    },
    {
      id: 10,
      name: '膨胀助力'
    },
    {
      id: 11,
      name: '会员升级赠送'
    },
    {
      id: 12,
      name: '积分兑换'
    },
    {
      id: 13,
      name: '手动发券'
    },
    {
      id: 14,
      name: '请Ta'
    },
    {
      id: 15,
      name: '优惠码兑换'
    },
    {
      id: 16,
      name: '团购优惠券'
    },
    {
      id: 17,
      name: '消费赠券'
    },
    {
      id: 18,
      name: '转赠获取'
    }
  ],
  COUPON_ATTRIBUTE: [
    {
      id: 1,
      name: '普通券'
    },
    {
      id: 2,
      name: '膨胀券'
    }
    // {
    //   id: 3,
    //   name: '请Ta券'
    // }
  ],
  COUPON_GIVE: [
    {
      id: 1,
      name: '未使用'
    },
    {
      id: 2,
      name: '已使用'
    },
    {
      id: 3,
      name: '已赠送'
    },
    {
      id: 4,
      name: '赠送中'
    },
    {
      id: 5,
      name: '已过期'
    }
  ],
  USED_STATUS: [
    {
      id: 1,
      name: '未使用'
    },
    {
      id: 2,
      name: '已使用'
    }
  ],
  POINT_TYPE_STATUS: [
    {
      id: 1,
      name: '优卡赠送'
    },
    {
      id: 2,
      name: '订单消费'
    },
    {
      id: 3,
      name: '订单退款'
    },
    {
      id: 4,
      name: '积分兑换'
    },
    {
      id: 5,
      name: '过期'
    },
    {
      id: 6,
      name: '手动增加'
    },
    {
      id: 7,
      name: '手动减少'
    },
    {
      id: 8,
      name: '会员升级赠送'
    },
    {
      id: 9,
      name: '导入'
    }
  ],
  PAY_METHOD_STATUS: [
    {
      id: '1',
      name: '微信'
    },
    {
      id: '2',
      name: '支付宝'
    },
    {
      id: '3',
      name: '其它'
    },
    {
      id: '4',
      name: '优卡'
    },
    {
      id: '5',
      name: '通付卡'
    },
    {
      id: '6',
      name: '组合支付'
    },
    {
      id: '7',
      name: '现金'
    },
    {
      id: '9',
      name: '对公转账'
    }
  ],
  PAY_SCENE_STATUS: [
    {
      id: '1',
      name: '商家后台'
    },
    {
      id: '2',
      name: '犀团管理系统'
    }
    // {
    //   id: '3',
    //   name: '犀团助手小程序'
    // },
    // {
    //   id: '4',
    //   name: '门店POS'
    // }
  ],
  PAY_STATUS: [
    { id: 0, name: '未支付' },
    { id: 1, name: '已支付' },
    { id: 2, name: '部分支付' },
    { id: 3, name: '支付中' },
    { id: 4, name: '后支付' }
  ],
  ORDER_ORIGIN: [
    { id: 1, name: '微信小程序' },
    { id: 2, name: 'iPadPOS' },
    { id: 3, name: '商家后台' },
    { id: 4, name: '美团点评' },
    { id: 5, name: '犀团助手' },
    { id: 6, name: '抖音核销' },
    { id: 7, name: '网页POS' },
    { id: 8, name: '三方系统' },
    { id: 9, name: '安卓POS' },
    { id: 10, name: '抖音小程序' },
    { id: 11, name: '无人收衣舱' },
    { id: 12, name: '无人收发柜' }
  ],
  CLOTH_NOTICE: [
    {
      id: 1,
      name: '订单质检后'
    },
    {
      id: 2,
      name: '订单到店后'
    },
    {
      id: 3,
      name: '不发送'
    }
  ],
  // 店铺类型
  STORE_TYPE: [
    {
      id: 1,
      name: '实体店铺'
    },
    {
      id: 2,
      name: '美团店铺'
    },
    {
      id: 3,
      name: '抖音店铺'
    },
    {
      id: 4,
      name: '无人自助店'
    },
    {
      id: 5,
      name: '无人收衣舱'
    },
    {
      id: 6,
      name: '服务中心'
    },
    {
      id: 7,
      name: '无人收发柜'
    }
  ],
  // 快递类型
  DELIVERY_TYPE: [
    {
      id: 'JD',
      name: '京东快递'
    },
    {
      id: 'SF',
      name: '顺丰速运'
    }
  ],
  // 取/送件
  DELIVERY_GET_TYPE: [
    {
      id: 1,
      name: '取件'
    },
    {
      id: 2,
      name: '送件'
    }
  ],
  // 快递收签时间
  DELIVERY_TIME_TYPE: [
    {
      id: '1',
      name: '下单时间'
    },
    {
      id: '2',
      name: '揽件时间'
    },
    {
      id: '3',
      name: '签收时间'
    }
  ],
  // 快递状态
  DELIVERY_STATUS: [
    { val: '-1', text: '派单失败' },
    { val: '1', text: '已下单' },
    { val: '3', text: '已接单' },
    { val: '5', text: '已揽收' },
    { val: '7', text: '送件中' },
    { val: '9', text: '已签收' },
    { val: '10', text: '已拒收' }
  ],
  // 工厂属性
  FACTORY_NOTICE: [
    { id: '1', name: '仅是门店' },
    { id: '2', name: '仅是洗护工厂' },
    { id: '3', name: '既是门店也是洗护工厂' }
  ],
  // 赠送状态
  SOLVE_STATUS: [
    { id: '1', name: '未赠送' },
    { id: '2', name: '赠送中' },
    { id: '3', name: '已赠送' }
  ],
  GUJIA_PAY_TYPE: [
    { id: '1', name: '微信' },
    { id: '10', name: '估价卡' }
  ],
  GUJIA_RECORD_TYPE: [
    { id: '1', name: '手动赠卡' },
    { id: '2', name: '新人赠卡' },
    { id: '3', name: '消费' }
  ],
  WX_MSG_STATUS: [
    { id: '0', name: '未开始' },
    { id: '1', name: '执行中' },
    { id: '2', name: '已完成' }
  ],
  WX_MSG_TO: [
    { id: 'single', name: '发给客户' },
    { id: 'group', name: '发给社群' },
    { id: 'moment', name: '发给朋友圈' }
  ],
  WX_PAY_TYPE_CITY: [
    { id: '1', name: '微信' },
    { id: '2', name: '支付宝' }
  ],
  // 京东快递产品类型
  JINGDONG_DELIVERY_TYPE: [
    { id: 'ed-m-0001', name: '特惠送' },
    { id: 'ed-m-0002', name: '特快送' }
  ],
  // 顺丰速运产品类型
  SHUNFENG_DELIVERY_TYPE: [
    { id: '1', name: '顺丰特快' },
    { id: '2', name: '顺丰标快' },
    { id: '6', name: '顺丰即日' },
    { id: '10', name: '国际小包' },
    { id: '231', name: '陆运包裹' },
    { id: '247', name: '电商标快' },
    { id: '283', name: '填舱标快' },
    { id: '285', name: '填舱电标' }
  ],
  // 顺丰速运产品类型
  SHUNFENG_PAY_METHOD: [
    { id: 1, name: '寄方付' },
    { id: 2, name: '收方付' },
    { id: 3, name: '第三方付' }
  ],
  OTHER_EXPRESS: [
    {
      name: '顺丰速运',
      id: 'SF'
    },
    {
      name: '京东快递',
      id: 'JD'
    },
    {
      name: '跑腿',
      id: 'PT'
    },
    {
      name: '圆通',
      id: 'YT'
    },
    {
      name: '申通',
      id: 'ST'
    },
    {
      name: '中通',
      id: 'ZT'
    },
    {
      name: '百世汇通',
      id: 'HT'
    },
    {
      name: '韵达',
      id: 'YD'
    },
    {
      name: '德邦',
      id: 'DB'
    }
  ],
  INSURE_STATUS: [
    {
      name: '投保成功',
      id: '1'
    },
    {
      name: '投保失败',
      id: '2'
    },
    {
      name: '取消投保',
      id: '3'
    }
  ],
  DY_ORDER_TYPE: [
    {
      name: '洗护订单',
      id: 1
    },
    {
      name: '家政订单',
      id: 2
    },
    {
      name: '商品订单',
      id: 3
    }
  ],
  THIRD_SYSTEM: [
    {
      name: '犀团',
      id: 1
    },
    {
      name: '浣洗',
      id: 2
    },
    {
      name: '京东洗衣',
      id: 3
    },
    {
      name: '丰巢洗衣',
      id: 4
    },
    {
      name: '五优生活',
      id: 5
    },
    {
      name: '洗衣管家',
      id: 6
    },
    {
      name: '南威',
      id: 7
    },
    {
      name: '优洗',
      id: 8
    },
    {
      name: '新丰巢洗护',
      id: 9
    }
  ],
  CARD_TYPE: [
    {
      name: '储值卡',
      id: 1
    },
    {
      name: '权益卡',
      id: 2
    }
  ],
  RECEIVING_ACCOUNT: [
    {
      name: '银行卡',
      id: 1
    },
    {
      name: '支付宝',
      id: 2
    },
    {
      name: '微信零钱',
      id: 3
    },
    {
      name: '储值卡',
      id: 4
    }
  ],
  USER_LIST_TIME_TYPE: [
    {
      name: '创建时间',
      id: '1'
    },
    {
      name: '生日时间',
      id: '2'
    }
  ],
  DEVICE_RUN_STATUS_TYPE: [
    {
      id: '1',
      name: 'HMI'
    },
    {
      id: '2',
      name: 'MCU'
    }
  ],
  DEVICE_RUN_STATUS_VALUE: [
    {
      id: '1',
      name: '正常'
    },
    {
      id: '2',
      name: '异常'
    }
  ],
  PARTNER_COMMISSION_TYPE: [
    {
      id: '1',
      name: '商品订单'
    },
    {
      id: '2',
      name: '洗护订单'
    },
    {
      id: '3',
      name: '家政订单'
    },
    {
      id: '4',
      name: '礼券订单'
    },
    {
      id: '5',
      name: '分拣'
    },
    {
      id: '6',
      name: '取件'
    },
    {
      id: '7',
      name: '送件'
    }
  ],
  API_SYS_TYPE: [
    {
      id: '1',
      name: '五优生活'
    }
  ],
  CLOUD_PRINT_BRAND: [
    {
      id: '1',
      name: '商米'
    },
    {
      id: '2',
      name: '飞鹅'
    }
  ],
  CLOUD_PRINT_TEMPLATE: [
    {
      id: '1',
      name: '80mm'
    },
    {
      id: '2',
      name: '58mm'
    },
    {
      id: '3',
      name: '40*30mm'
    },
    {
      id: '4',
      name: '45*30mm'
    }
  ],
  CLOUD_PRINT_TYPE: [
    {
      id: '1',
      name: '订单小票'
    },
    {
      id: '2',
      name: '商品票-小票'
    },
    {
      id: '3',
      name: '商品票-不干胶'
    }
  ],
  POINTS_COLLECTION: [
    {
      id: '1',
      name: '消费加集点'
    },
    {
      id: '2',
      name: '集点兑换'
    },
    {
      id: '3',
      name: '退款减集点'
    }
  ]
}
